import React from "react"
import Link from 'gatsby-link'

class LocationGridItem extends React.Component {

  // descriptionHQ sends the 'colorado' location a special text block
  descriptionHQ() { 
    if ( this.props.path === '/colorado' ) {
      return (
        <div className="pfb-grid-item-desc">People for Bikes Headquarters</div>
      )
    }
  }

  render() {
    return (
      <div className="grid-fade-in">
        <Link to={ this.props.path }>
          <section>
            <h2 className="pfb-location-grid-title" id={ this.props.id }>
              { this.props.location }
            </h2>
            { this.descriptionHQ() }
          </section>
        </Link> 
      </div>
    )
  }
}

export default LocationGridItem


// WEBPACK FOOTER //
// ./src/components/LocationGridItem/index.js